const MAX_STARS = 5;
const PERCENT = 100;

export const ratingToPercent = (rating: number): number =>
  Math.round((rating / MAX_STARS) * PERCENT);
